import { Button } from '@material-ui/core';
import { Link } from 'react-router-dom';

const ACCENT_CLASS = '!bg-[#063447] hover:!bg-[#042a36] !text-white';
const DISABLED_CLASS = '!bg-[#7da0b3] !text-white/70 cursor-not-allowed';

const AccentButton = ({ children, to, component, disabled = false, className = '', ...props }) => {
  const baseClasses =
    'px-6 py-2 normal-case font-semibold rounded-md transition-colors duration-200';
  const colorClasses = disabled ? DISABLED_CLASS : ACCENT_CLASS;

  const buttonProps = {
    ...props,
    disabled,
    className: `${baseClasses} ${colorClasses} ${className}`.trim(),
  };

  if (to && !disabled) {
    buttonProps.component = Link;
    buttonProps.to = to;
  } else if (component) {
    buttonProps.component = component;
  }

  return <Button {...buttonProps}>{children}</Button>;
};

export default AccentButton;
